export enum IncidencesTypes  { Warning = 'Aviso', Error = 'Incidencia' };